angular.module('app').factory('MimeTypeRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        function getMimeTypeFromFileExtension(requestedMimeTypes) {
            var types = JSON.stringify(requestedMimeTypes);

            var params = {
                FileExtensions : types
            };

            var restangular = AprimaRestangular.get('patient');

            return restangular.one('patients/').customGET('mimetype/from-file-extension', params);
        }

        return {
            getMimeTypeFromFileExtension: getMimeTypeFromFileExtension
        };

    }]);